import React, { useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* <Header onMenuClick={() => setSidebarOpen(true)} /> */}
      <div className="lg:pl-64">
        <main className="p-4 lg:p-6">{children}</main>
      </div>
      {/* <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} /> */}
    </div>
  );
};

export default Layout;